<section class="dashboard">
  <div class="ui_l">
    <div class="devices">
      <Select class="select" h="xl" :options="state.groups_op" v-model:selected="state.groups"></Select>
    </div>
    <div class="Status">
      <CircleChart class="Connection" :title="t('__d7d_n17r.__connectionStatus')" :data="state.Connection" :table_title_name="t('__d7d_n17r.__period')" :total_text="t('__d7d_n17r.__connected')">
      </CircleChart>
      <CircleChart class="Calibration" :title="t('__d7d_n17r.__calibrationStatus')" :data="state.Calibration" :table_title_name="t('__d7d_n17r.__period')"
        :total_text="t('__d7d_n17r.__calibratedWithinNumMonth', { num: '6' })"></CircleChart>
    </div>
    <div class="text_chart">
      <div class="chart n1">
        <p class="title">{{t('__d7d_n17r.__amount')}}</p>
        <div class="value" v-if="state.groups.val == 'All'">
          <p class="val">{{state.value_L_1}}</p>
          <p class="name">{{t('__d7d_n17r.__groups')}}</p>
        </div>
        <div class="value" :class="state.groups.val=='All'?'':'large'">
          <p class="val">{{state.value_L_2}}</p>
          <p class="name">{{t('__d7d_n17r.__devices')}}</p>
        </div>
      </div>
      <div class="chart n2">
        <p class="title">{{t('__d7d_n17r.__task')}} / {{t('__d7d_n17r.__appointmentAmount')}}</p>
        <div class="value">
          <p class="val">{{state.value_R_1}}</p>
          <p class="name">{{t('__d7d_n17r.__appointments')}}</p>
        </div>
        <div class="value">
          <p class="val">{{state.value_R_2}}</p>
          <p class="name">{{t('__d7d_n17r.__excutedTasks')}}</p>
        </div>
      </div>
    </div>
    <div v-for="value in state.line_chart_array" class="line_chart">
      <p class="title">{{value.title}}</p>
      <div class="content_flex">
        <p class="content">{{t('__d7d_n17r.__modelName')}}：{{value.model}}｜{{t('__d7d_n17r.__date')}}：{{value.time}}｜{{value.total}} {{t('__d7d_n17r.__devicesInTotal')}}</p>
        <Button class="btn" h="sm" type="border" :text="t('__d7d_n17r.__details')" @onClick="details(value.id)"></Button>
      </div>
      <Linebar class="bar" :data="value.data"></Linebar>
    </div>
  </div>
  <div class="ui_r">
    <div class="top">
      <div class="title">{{t('__d7d_n17r.__askForBinding')}} ({{state.list_number}})</div>
      <!-- <div class="bells">
        <button @Click="onClick">
          
          <iCon class="icon" iconClass="asus_proart_sw_ico_notification" style=" width: 28px;height: 28px;"></iCon>
        </button>
        <div class="dot" v-if="state.newNews"></div>
      </div> -->
    </div>
    <div class="empty" v-if="!state.list_data.length">{{t('__d7d_n17r.__noBindingRequest')}}</div>
    <div class="return_all" v-if="state.list_data.length">
      <Button class="btn" h="md" type="border" :text="t('__d7d_n17r.__agreeAll')" @onClick="approve_click_all"></Button>
      <Button class="btn" h="md" type="border" :text="t('__d7d_n17r.__rejectAll')" @onClick="delete_click_all"></Button>
    </div>
    <div v-for="(value ,index) in state.list_data" :id="'dashboardAsk'+index"
    class="data " tabindex="0"  @focus="hasFocus(index)">
      <p class="name">{{value.name}}</p>
      <div class="info">{{t('__d7d_n17r.__deviceSsnFromPcRequestForBinding',{sn_no : value.name, pc_no : value.info})}}</div>
      
      <p class="info">{{state.focusState}}11111 {{t('__common.__model')}} : {{value.model}} | {{t('__common.__ip')}}: {{value.ip}} </p>
    <div class="return" :class="{'hasFocus' : state.focusState == index}">
        <button class="check" @click.stop="approve_click(value.approve_id)">
          <iCon class="check_icon" iconClass="check" style=" width: 17px;height: 17px;"></iCon>
        </button>
        <button class="cancel" @click.stop="delete_click(value.approve_id)"  >
          <iCon class="cancel_icon" iconClass="asus_proart_sw_ico_cancel" style=" width: 17px;height: 17px;"></iCon>
        </button>
      </div>
    </div>
    <div class="page" v-if="state.list_data.length">
      <button :class="[state.page>1?'able':'disable']" @click.stop="click_page('-')">
        <iCon class="icon" iconClass="asus_proart_sw_ico_last" style=" width: 13px;height: 13px;"></iCon>
      </button>
      <div class="number">{{state.page}}/{{page_max}}</div>
      <button :class="[state.page<page_max?'able':'disable']" @click.stop="click_page('+')">
        <iCon class="icon" iconClass="asus_proart_sw_ico_next-more" style=" width: 13px;height: 13px;"></iCon>
      </button>
    </div>
  </div>
</section>